export default class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll('.accordion');
        
        this.ready();
    }

    ready() {

        this.accordions.forEach(accordion => {
            const accordionsItems = accordion.querySelectorAll('.accordion--item')
            if(accordionsItems.length > 0) {
                accordionsItems.forEach(item => {
                    if(accordionsItems.length === 1) {
                        item.classList.add('open')
                    }
                    const titulo = item.querySelector('.title')
                    titulo.addEventListener('click', () => {
                        item.classList.toggle('open')
                    })
                })
            }

        })
        
    }
}

if (document.querySelector('.accordion')) {
    new Accordion();
}
